module.exports = __webpack_public_path__ + "img/infographic.72e34138.jpg";